// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"7004":"4104877e","7419":"54635547"}[chunkId] + ".chunk.css");